import { mapState, mapMutations } from 'vuex';
import { validationFormMixin } from '../../../shared/mixins/validationFormMixin';
import {
  fetchPaymentMethods,
  createPaymentMethods,
  updatePaymentMethods,
  deletePaymentMethods,
} from '../../helpers/KnFinancialOptions';
import { paginationMixin } from '@/modules/shared/mixins/paginationMixin';

export default {
  components: {
    KnFormSubtitle: () =>
      import('../../../shared/components/KnFormSubtitle/KnFormSubtitle.vue'),
    KnFormActionButtons: () =>
      import(
        '../../../shared/components/KnFormActionButtons/KnFormActionButtons.vue'
      ),
    KnListWithActions: () =>
      import(
        '../../../shared/components/KnListWithActions/KnListWithActions.vue'
      ),
  },
  mixins: [paginationMixin, validationFormMixin],
  data() {
    return {
      errors: [],
      valid: true,
      paymentMethod: {
        id: 'NA', // No asignado
        dato: null,
        id_autor: null,
        id_institucion_educativa: null,
      },
      methods: [],
      toUpdate: false,
      showInactive: false,
      loading: false,
    };
  },
  async created() {
    this.setIsLogin(false);
    await this.getPaginatedPaymentMethods(1);
    this.paymentMethod.id_autor = this.userData.id;
    this.paymentMethod.id_institucion_educativa = this.institutionId;
  },
  computed: {
    ...mapState(['institutionId', 'userData']),
    actionTitle() {
      return this.toUpdate ? 'Actualizar' : 'Agregar';
    },
    invalidFields() {
      return this.objectHasNulls(this.paymentMethod);
    },
  },
  watch: {
    showInactive: {
      async handler() {
        await this.getPaginatedPaymentMethods(1);
      },
    },
    institutionId: {
      async handler() {
        this.setIsLogin(false);
        await this.getPaginatedPaymentMethods(1);
        this.paymentMethod.id_autor = this.userData.id;
        this.paymentMethod.id_institucion_educativa = this.institutionId;
      },
    },
  },
  methods: {
    ...mapMutations(['setIsLogin']),
    async getPaginatedPaymentMethods(page = 1) {
      try {
        this.methods = [];
        this.setPaginationPage(page);

        if (!this.loading) {
          this.loading = true;

          const { ok, data, message, count } = await fetchPaymentMethods({
            institutionId: this.institutionId,
            systemStatus: !this.showInactive,
            limit: this.pagination.limit,
            offset: this.pagination.offset,
          });

          if (ok) {
            this.setPaginationCount(count);
            for (const paymentMethod of data) {
              this.methods.push({ ...paymentMethod });
            }
          } else {
            console.error(
              'No se pudieron obtener los tipos de empleados',
              message
            );
          }

          this.loading = false;
        }
      } catch (error) {
        console.error('Error al obtener los tipos de empleados:', error);
        this.loading = false;
      }
    },
    async save() {
      await createPaymentMethods(
        this.paymentMethod.dato,
        this.paymentMethod.id_autor,
        this.paymentMethod.id_institucion_educativa
      );
      await this.getPaginatedPaymentMethods(1);
      this.clear();
    },
    clear() {
      this.paymentMethod = {
        id: 'NA', // No asignado
        dato: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    clearInline() {
      this.paymentMethod = {
        id: 'NA', // No asignado
        dato: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    async updateInline(item) {
      // console.log('updateInline item', item);
      this.paymentMethod = { ...item };
      await updatePaymentMethods(
        this.paymentMethod.id,
        this.paymentMethod.dato,
        this.paymentMethod.id_autor,
        this.paymentMethod.id_institucion_educativa
      );
      await this.getPaginatedPaymentMethods(1);
      this.clearInline();
    },
    async deleteInline(itemId) {
      await deletePaymentMethods(itemId);
      await this.getPaginatedPaymentMethods(1);
      this.clearInline();
    },
  },
};
